import css_4drvu4t89bg from './css/CallToAction.css';
import Div from '../Elements/Div.js';
import Time from '../Elements/Time.js';

const css = css_4drvu4t89bg;

export default class CallToAction extends Div
{
	constructor(parentElement)
	{
		super(parentElement);

		this.playButton = new PlayButton(this);
		this.action = new Action(this);
		this.time = new Time(this);
	}

	get cssText()
	{
		return css;
	}
}

class Action extends Div {}
class PlayButton extends Div {}